import urlConditional from "./apiInfo";
const location = urlConditional();

const RentRequestAPI = {
  getRentRequests() {
    return fetch(`${location}/get-rent-requests`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }).then((resp) => resp.json());
  },
};

export default RentRequestAPI;
